import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './LegalPage.css';

const Terms = () => {
  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{t.terms.title}</h1>
        <p className="legal-updated">{t.terms.lastUpdated}: December 1, 2024</p>
        
        <section>
          <h2>{t.terms.section1.title}</h2>
          <p>{t.terms.section1.content}</p>
        </section>

        <section>
          <h2>{t.terms.section2.title}</h2>
          <p>{t.terms.section2.content}</p>
        </section>

        <section>
          <h2>{t.terms.section3.title}</h2>
          <p>{t.terms.section3.content}</p>
        </section>

        <section>
          <h2>{t.terms.section4.title}</h2>
          <p>{t.terms.section4.content}</p>
        </section>

        <section>
          <h2>{t.terms.contact.title}</h2>
          <p>{t.terms.contact.content}</p>
          <p><a href="mailto:jinhuqi@agentecfusion.com">jinhuqi@agentecfusion.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
